<template>
  <v-card color="primary">
    <v-card-title class="font-weight-bold">Environment Information</v-card-title>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Name</th>
              <th>Network Inspector</th>
              <th>Baseline Comparison</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-bind:class="{error: isError(ele)}" v-for="ele in sensorType" :key="ele.type">
              <td><v-img :src= "ele.image" width="20"></v-img></td>
              <td>{{ ele.type.charAt(0).toUpperCase() + ele.type.slice(1) }}</td>
              <td>{{ displayCount(ele) }}</td>
              <td>{{ displayBaselineChange(ele) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
</template>


<script>
export default {
    props: {
      sensorType: Array,
      environmentInfo: Object,
      baselineInfo: Object
    },
    computed: {
    },
    methods: {
      displayCount: function(ele) {
        if (this.environmentInfo[ele.type] != undefined) {
          return this.environmentInfo[ele.type];
        } else {
          return 0;
        }
      },
      displayBaselineChange: function(ele) {
        if (this.baselineInfo[ele.type] != undefined) {
          return this.baselineInfo[ele.type];
        } else {
          return 0;
        }
      },
      isError: function(ele) {
        if (this.environmentInfo[ele.type] != this.baselineInfo[ele.type]) {
          return true;
        } else {
          return false;
        }
      }
    },
    mounted: function() {
    }
}
</script>